module.exports = __webpack_public_path__ + "static/media/5-wood.9ec4adff.png";